import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=5ac951bf&scoped=true&"
import script from "./partner.vue?vue&type=script&lang=js&"
export * from "./partner.vue?vue&type=script&lang=js&"
import style0 from "./partner.vue?vue&type=style&index=0&id=5ac951bf&prod&lang=scss&scoped=true&"
import style1 from "./partner.vue?vue&type=style&index=1&id=5ac951bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac951bf",
  null
  
)

export default component.exports